"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeMediafileDownloadDelay = exports.updateMediafileDownloadDelay = exports.restoreMediafileInDownloadQueue = exports.removeFileDownloadError = exports.updateFileDownloadError = exports.removeMediafileFromCurrentlyCleaningUp = exports.removeMediafileFromCurrentlyDownloading = exports.addMediafileToCurrentlyDownloading = exports.insertMediafilesToDownloadQueue = exports.addMediafilesToDownloadQueue = exports.emptyMediafileDownloadQueue = exports.setMediafileDownloadQueue = exports.addMediafileToCurrentlyCleaningUp = exports.setMediafilesCleanupQueue = exports.addMediafilesToCleanupQueue = void 0;
var Mediafiles_1 = __importDefault(require("../services/Mediafiles"));
var initialState = {
    mediafileDownloadErrors: {},
    mediafileDownloadDelays: {},
    mediafileDownloadQueue: [],
    currentDownloading: [],
    mediafileCleanupQueue: [],
    currentCleaningUp: [],
};
function addMediafilesToCleanupQueue() {
    var mediafiles = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        mediafiles[_i] = arguments[_i];
    }
    return {
        type: addMediafilesToCleanupQueue.type,
        payload: {
            mediafiles: mediafiles,
        },
    };
}
exports.addMediafilesToCleanupQueue = addMediafilesToCleanupQueue;
addMediafilesToCleanupQueue.type = "mediafilesMeta/addMediafilesToCleanupQueue";
function setMediafilesCleanupQueue() {
    var mediafiles = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        mediafiles[_i] = arguments[_i];
    }
    return {
        type: setMediafilesCleanupQueue.type,
        payload: {
            mediafiles: mediafiles,
        },
    };
}
exports.setMediafilesCleanupQueue = setMediafilesCleanupQueue;
setMediafilesCleanupQueue.type = "mediafilesMeta/setMediafilesCleanupQueue";
function addMediafileToCurrentlyCleaningUp(mediafile) {
    return {
        type: addMediafileToCurrentlyCleaningUp.type,
        payload: {
            mediafile: mediafile,
        },
    };
}
exports.addMediafileToCurrentlyCleaningUp = addMediafileToCurrentlyCleaningUp;
addMediafileToCurrentlyCleaningUp.type = "mediafilesMeta/addMediafileToCurrentlyCleaningUp";
function setMediafileDownloadQueue(mediafileIds) {
    return {
        type: setMediafileDownloadQueue.type,
        payload: {
            mediafileIds: mediafileIds,
        },
    };
}
exports.setMediafileDownloadQueue = setMediafileDownloadQueue;
setMediafileDownloadQueue.type = "mediafilesMeta/setMediafileDownloadQueue";
function emptyMediafileDownloadQueue() {
    return {
        type: emptyMediafileDownloadQueue.type,
        payload: {},
    };
}
exports.emptyMediafileDownloadQueue = emptyMediafileDownloadQueue;
emptyMediafileDownloadQueue.type = "mediafilesMeta/emptyMediafileDownloadQueue";
function addMediafilesToDownloadQueue() {
    var mediafileIds = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        mediafileIds[_i] = arguments[_i];
    }
    return {
        type: addMediafilesToDownloadQueue.type,
        payload: {
            mediafileIds: mediafileIds,
        },
    };
}
exports.addMediafilesToDownloadQueue = addMediafilesToDownloadQueue;
addMediafilesToDownloadQueue.type = "mediafilesMeta/addMediafilesToDownloadQueue";
function insertMediafilesToDownloadQueue() {
    var mediafileIds = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        mediafileIds[_i] = arguments[_i];
    }
    return {
        type: insertMediafilesToDownloadQueue.type,
        payload: {
            mediafileIds: mediafileIds,
        },
    };
}
exports.insertMediafilesToDownloadQueue = insertMediafilesToDownloadQueue;
insertMediafilesToDownloadQueue.type = "mediafilesMeta/insertMediafilesToDownloadQueue";
function addMediafileToCurrentlyDownloading(mediafileId) {
    return {
        type: addMediafileToCurrentlyDownloading.type,
        payload: {
            mediafileId: mediafileId,
        },
    };
}
exports.addMediafileToCurrentlyDownloading = addMediafileToCurrentlyDownloading;
addMediafileToCurrentlyDownloading.type = "mediafilesMeta/addMediafileToCurrentlyDownloading";
function removeMediafileFromCurrentlyDownloading(mediafileId) {
    return {
        type: removeMediafileFromCurrentlyDownloading.type,
        payload: {
            mediafileId: mediafileId,
        },
    };
}
exports.removeMediafileFromCurrentlyDownloading = removeMediafileFromCurrentlyDownloading;
removeMediafileFromCurrentlyDownloading.type =
    "mediafilesMeta/removeMediafileFromCurrentlyDownloading";
function removeMediafileFromCurrentlyCleaningUp(mediafileId) {
    return {
        type: removeMediafileFromCurrentlyCleaningUp.type,
        payload: {
            mediafileId: mediafileId,
        },
    };
}
exports.removeMediafileFromCurrentlyCleaningUp = removeMediafileFromCurrentlyCleaningUp;
removeMediafileFromCurrentlyCleaningUp.type =
    "mediafilesMeta/removeMediafileFromCurrentlyCleaningUp";
function updateFileDownloadError(mediafileComposeKey, delay, increaseDelay) {
    return {
        type: updateFileDownloadError.type,
        payload: {
            key: mediafileComposeKey,
            delay: delay,
            increaseDelay: increaseDelay,
        },
    };
}
exports.updateFileDownloadError = updateFileDownloadError;
updateFileDownloadError.type = "mediafilesMeta/updateFileDownloadError";
function removeFileDownloadError(mediafileComposeKey) {
    return {
        type: removeFileDownloadError.type,
        payload: { key: mediafileComposeKey },
    };
}
exports.removeFileDownloadError = removeFileDownloadError;
removeFileDownloadError.type = "mediafilesMeta/removeFileDownloadError";
function restoreMediafileInDownloadQueue(mediafileId) {
    return {
        type: restoreMediafileInDownloadQueue.type,
        payload: {
            mediafileId: mediafileId,
        },
    };
}
exports.restoreMediafileInDownloadQueue = restoreMediafileInDownloadQueue;
restoreMediafileInDownloadQueue.type = "mediafilesMeta/restoreMediafileInDownloadQueue";
function updateMediafileDownloadDelay(mediafileId, delay, increaseDelay) {
    return {
        type: updateMediafileDownloadDelay.type,
        payload: {
            mediafileId: mediafileId,
            delay: delay,
            increaseDelay: increaseDelay,
        },
    };
}
exports.updateMediafileDownloadDelay = updateMediafileDownloadDelay;
updateMediafileDownloadDelay.type = "mediafilesMeta/updateMediafileDownloadDelay";
function removeMediafileDownloadDelay(mediafileId) {
    return {
        type: removeMediafileDownloadDelay.type,
        payload: {
            mediafileId: mediafileId,
        },
    };
}
exports.removeMediafileDownloadDelay = removeMediafileDownloadDelay;
removeMediafileDownloadDelay.type = "mediafilesMeta/removeMediafileDownloadDelay";
function mediafilesMetaReducer(state, action) {
    var _a, _b, _c;
    var _d, _e;
    if (state === void 0) { state = initialState; }
    var queue;
    switch (action.type) {
        case updateFileDownloadError.type:
            return __assign(__assign({}, state), { mediafileDownloadErrors: __assign(__assign({}, state.mediafileDownloadErrors), (_a = {}, _a[action.payload.key] = Mediafiles_1.default.getFileErrorDownloadDelay(action.payload.delay, action.payload.increaseDelay, state.mediafileDownloadErrors[action.payload.key]), _a)) });
        case removeFileDownloadError.type:
            return __assign(__assign({}, state), { mediafileDownloadErrors: state.mediafileDownloadErrors[action.payload.key]
                    ? Object.fromEntries(Object.entries(state.mediafileDownloadErrors).filter(function (_a) {
                        var _b = __read(_a, 2), key = _b[0], _ = _b[1];
                        return key !== action.payload.key;
                    }))
                    : state.mediafileDownloadErrors });
        case updateMediafileDownloadDelay.type:
            return __assign(__assign({}, state), { mediafileDownloadDelays: __assign(__assign({}, state.mediafileDownloadDelays), (_b = {}, _b[action.payload.mediafileId] = Mediafiles_1.default.getFileErrorDownloadDelay(action.payload.delay, action.payload.increaseDelay, state.mediafileDownloadDelays[action.payload.mediafileId]), _b)), mediafileDownloadQueue: __spreadArray(__spreadArray([], __read(state.mediafileDownloadQueue.filter(function (id) { return id !== action.payload.mediafileId; })), false), [
                    action.payload.mediafileId,
                ], false), currentDownloading: state.currentDownloading.filter(function (mfId) { return mfId !== action.payload.mediafileId; }) });
        case removeMediafileDownloadDelay.type:
            return __assign(__assign({}, state), { mediafileDownloadDelays: __assign({}, Object.fromEntries(Object.entries(state.mediafileDownloadDelays).filter(function (_a) {
                    var _b = __read(_a, 2), id = _b[0], _ = _b[1];
                    return id !== action.payload.mediafileId;
                }))) });
        case addMediafileToCurrentlyDownloading.type:
            return __assign(__assign({}, state), { currentDownloading: __spreadArray(__spreadArray([], __read(state.currentDownloading), false), [action.payload.mediafileId], false) });
        case removeMediafileFromCurrentlyDownloading.type:
            return __assign(__assign({}, state), { mediafileDownloadQueue: state.mediafileDownloadQueue.filter(function (mfId) { return mfId !== action.payload.mediafileId; }), currentDownloading: state.currentDownloading.filter(function (mfId) { return mfId !== action.payload.mediafileId; }), mediafileDownloadDelays: __assign({}, Object.fromEntries(Object.entries(state.mediafileDownloadDelays).filter(function (_a) {
                    var _b = __read(_a, 2), id = _b[0], delay = _b[1];
                    return id !== action.payload.mediafileId;
                }))) });
        case setMediafileDownloadQueue.type:
            return __assign(__assign({}, state), { mediafileDownloadQueue: Array.from(new Set(action.payload.mediafileIds)) });
        case emptyMediafileDownloadQueue.type:
            var current_1 = new Set(state.currentDownloading);
            return __assign(__assign({}, state), { mediafileDownloadQueue: state.mediafileDownloadQueue.filter(function (id) { return current_1.has(id); }) });
        case addMediafilesToDownloadQueue.type:
            return __assign(__assign({}, state), { mediafileDownloadQueue: __spreadArray(__spreadArray([], __read(((_d = state.mediafileDownloadQueue) !== null && _d !== void 0 ? _d : []).filter(function (id) { return !action.payload.mediafileIds.includes(id); })), false), __read(action.payload.mediafileIds), false) });
        case insertMediafilesToDownloadQueue.type:
            return __assign(__assign({}, state), { mediafileDownloadQueue: __spreadArray(__spreadArray([], __read(action.payload.mediafileIds), false), __read(((_e = state.mediafileDownloadQueue) !== null && _e !== void 0 ? _e : []).filter(function (id) { return !action.payload.mediafileIds.includes(id); })), false) });
        case restoreMediafileInDownloadQueue.type:
            queue = __spreadArray(__spreadArray([], __read(state.mediafileDownloadQueue.filter(function (id) { return id !== action.payload.mediafileId; })), false), [
                action.payload.mediafileId,
            ], false);
            return __assign(__assign({}, state), { mediafileDownloadQueue: queue, currentDownloading: state.currentDownloading.filter(function (mfId) { return mfId !== action.payload.mediafileId; }) });
        case addMediafilesToCleanupQueue.type:
            var toCleanupIds_1 = new Set(action.payload.mediafiles.map(function (item) { return item.id; }));
            return __assign(__assign({}, state), { mediafileCleanupQueue: __assign(__assign({}, Object.fromEntries(Object.entries(state.mediafileCleanupQueue).filter(function (_a) {
                    var _b = __read(_a, 2), mediafileId = _b[0], _ = _b[1];
                    return !toCleanupIds_1.has(mediafileId);
                }))), Object.fromEntries(action.payload.mediafiles.map(function (item) { return [item.id, item]; }))) });
        case setMediafilesCleanupQueue.type:
            return __assign(__assign({}, state), { mediafileCleanupQueue: __assign({}, Object.fromEntries(action.payload.mediafiles.map(function (item) { return [item.id, item]; }))) });
        case addMediafileToCurrentlyCleaningUp.type:
            return __assign(__assign({}, state), { currentCleaningUp: __assign(__assign({}, state.currentCleaningUp), (_c = {}, _c[action.payload.mediafile.id] = action.payload.mediafile, _c)) });
        case removeMediafileFromCurrentlyCleaningUp.type:
            return __assign(__assign({}, state), { currentCleaningUp: Object.fromEntries(Object.entries(state.currentCleaningUp).filter(function (_a) {
                    var _b = __read(_a, 2), id = _b[0], _ = _b[1];
                    return id !== String(action.payload.mediafileId);
                })), mediafileCleanupQueue: Object.fromEntries(Object.entries(state.mediafileCleanupQueue).filter(function (_a) {
                    var _b = __read(_a, 2), id = _b[0], _ = _b[1];
                    return id !== String(action.payload.mediafileId);
                })) });
        default:
            return state;
    }
}
exports.default = mediafilesMetaReducer;
//# sourceMappingURL=mediafilesMeta.js.map